<template>
  <div>
    <!-- pc -->
    <el-dialog
      title="登录"
      :visible.sync="$store.state.loginVisible && !$utils.isMobile()"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="content">
        <el-input v-model="userName" placeholder="请输入账号"></el-input>
        <el-input class="password-ipt" v-model="password" placeholder="请输入密码" show-password></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="login">登录</el-button>
      </span>
    </el-dialog>
    <!-- 手机 -->
    <el-drawer
      append-to-body
      size="80%"
      :visible.sync="$store.state.loginVisible && $utils.isMobile()"
      direction="btt"
      :before-close="handleClose"
      title="登录"
    >
      <div class="content">
        <el-input v-model="userName" placeholder="请输入账号"></el-input>
        <el-input class="password-ipt" v-model="password" placeholder="请输入密码" show-password></el-input>
      </div>
      <div class="drawer-footer">
        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { login } from "@/api/user/index.js";
export default {
  data() {
    return {
      userName: "",
      password: "",
    };
  },
  methods: {
    handleClose() {
      this.userName = "";
      this.password = "";
      this.$store.commit("setLoginVisible", false);
    },
    login() {
      let userForm = {
        userName: this.userName,
        password: this.$utils.md5Password(this.password),
      };
      login(userForm)
        .then((res) => {
          //token存在本地localStorage
          window.localStorage.setItem("accessToken", res.data.token);
          this.$store.commit("setUserData", res.data);
          this.handleClose();
          if (this.$route.path != "/home") {
            this.$router.replace("/home");
          } else {
            location.reload();
          }
        })
        .catch(({ data }) => {
          this.$store.commit("setUserData", {});
          this.$MessageBox.MessageWarning(data.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content,
.dialog-footer {
  padding: 0 2rem;
}
.password-ipt {
  margin-top: 1.5rem;
}
.drawer-footer {
  text-align: center;
  padding: 2rem;
}
</style>
